import cs from 'classnames';

import { filestackPath, initials, io } from 'lib/helpers/utility';
import useRandomGradient from 'lib/hooks/useRandomGradient';

import avatarMulti from './icons/avatar-multi.svg';
import avatarSingle from './icons/avatar-single.svg';
import { getClasses } from './lib/getClasses';

/**
 * @param {import('./lib/propTypes').AvatarProps} AvatarProps
 */

const Avatar = ({
  fullName,
  firstName,
  lastName,
  id,
  image,
  size = 'medium',
  fontSize,
  className,
  onClick,
  background = 'linear-gradient(98deg, #00ABE8 0%, #33C9FF 100%)',
  autoBackground = true,
  isSquare = true,
  iconIsMulti = false,
  ...rest
}) => {
  const gradientBackground = useRandomGradient(id);
  const backgroundStyle = id && autoBackground ? gradientBackground : background;
  const classes = getClasses(size);

  if (image && io(JSON.parse(image))) {
    return (
      <div
        className={cs(
          'flex min-w-[40px] items-center justify-center overflow-hidden',
          className,
          isSquare ? 'rounded-smooth' : 'rounded-full'
        )}
        style={{
          width: classes.size,
          height: classes.size,
          minWidth: classes.size,
          minHeight: classes.size
        }}
        onClick={onClick}
        data-private
        {...rest}>
        <img className="w-full object-contain" src={filestackPath(JSON.parse(image)?.jpg)} />
      </div>
    );
  }

  const initialsValue = initials(fullName ? { fullName } : { firstName, lastName });

  return (
    <div
      className={cs(
        'flex items-center justify-center overflow-hidden',
        className,
        isSquare ? 'rounded-smooth' : 'rounded-full'
      )}
      style={{
        width: classes.size,
        height: classes.size,
        minWidth: classes.size,
        minHeight: classes.size,
        background: backgroundStyle
      }}
      onClick={onClick}
      {...rest}>
      {initialsValue ? (
        <span
          className={cs(
            'font-600 uppercase !text-white',
            size === 'small' && 'leading-[14px]',
            fontSize ?? classes.fontSize
          )}>
          {initialsValue}
        </span>
      ) : (
        <img
          src={iconIsMulti ? avatarMulti : avatarSingle}
          alt=""
          aria-hidden="true"
          style={{ width: classes.size, height: classes.size }}
        />
      )}
    </div>
  );
};

export default Avatar;
